// extracted by mini-css-extract-plugin
export var brandLockup = "_gg-5";
export var brandLogo = "_gg-6";
export var bullet = "_gg-1i";
export var bulletText = "_gg-1h";
export var bullets = "_gg-1c";
export var callout = "_gg-12";
export var calloutBody = "_gg-14";
export var calloutLabel = "_gg-13";
export var checkIcon = "_gg-1e";
export var checkList = "_gg-1b";
export var checkSvg = "_gg-1f";
export var checkText = "_gg-1g";
export var choiceCard = "_gg-x";
export var choiceDescription = "_gg-10";
export var choiceIcon = "_gg-11";
export var choiceText = "_gg-y";
export var choiceTitle = "_gg-z";
export var closeButton = "_gg-d";
export var codeText = "_gg-28";
export var compactPage = "_gg-f";
export var content = "_gg-9";
export var contentColumn = "_gg-3";
export var coverageCard = "_gg-o";
export var coverageDescription = "_gg-24";
export var coverageTitle = "_gg-23";
export var eyebrow = "_gg-i";
export var fieldCard = "_gg-m";
export var fieldDescription = "_gg-r";
export var fieldError = "_gg-s";
export var fieldHeader = "_gg-p";
export var fieldTitle = "_gg-q";
export var finalNote = "_gg-29";
export var footer = "_gg-a";
export var fulfillmentBody = "_gg-1u";
export var fulfillmentBodyText = "_gg-1v";
export var fulfillmentRow = "_gg-1r";
export var fulfillmentRows = "_gg-1q";
export var fulfillmentTitle = "_gg-1t";
export var header = "_gg-4";
export var heading = "_gg-h";
export var helperText = "_gg-1k";
export var indented = "_gg-1x";
export var inlineLink = "_gg-26";
export var inlineTitle = "_gg-2a";
export var intro = "_gg-k";
export var linkPreview = "_gg-1z";
export var listItem = "_gg-1d";
export var main = "_gg-1";
export var marketingImage = "_gg-c";
export var marketingPanel = "_gg-b";
export var modal = "_gg-0";
export var noteBody = "_gg-v";
export var noteBodyText = "_gg-w";
export var noteCard = "_gg-n";
export var noteIcon = "_gg-t";
export var noteTitle = "_gg-u";
export var numberBadge = "_gg-2e";
export var numberedStep = "_gg-2c";
export var numberedStepBody = "_gg-2f";
export var numberedStepCta = "_gg-2d";
export var numberedStepDescription = "_gg-2h";
export var numberedStepTitle = "_gg-2g";
export var numberedSteps = "_gg-2b";
export var page = "_gg-e";
export var playCircle = "_gg-18";
export var playIcon = "_gg-19";
export var policyBody = "_gg-21";
export var policyHeader = "_gg-20";
export var policyPreview = "_gg-1y";
export var policyTitle = "_gg-22";
export var progressFill = "_gg-8";
export var progressTrack = "_gg-7";
export var pseudoLink = "_gg-25";
export var pseudoLinkIcon = "_gg-27";
export var rowHeader = "_gg-1s";
export var section = "_gg-g";
export var shell = "_gg-2";
export var statusIconSuccess = "_gg-1m";
export var statusIconSvg = "_gg-1o";
export var statusIconWarning = "_gg-1n";
export var statusRow = "_gg-1l";
export var statusText = "_gg-1p";
export var stepTitle = "_gg-j";
export var strongText = "_gg-1w";
export var subHeading = "_gg-l";
export var videoEmbed = "_gg-16";
export var videoIframe = "_gg-17";
export var videoLabel = "_gg-1a";
export var videoPlaceholder = "_gg-15";
export var warningIcon = "_gg-1j";